module.exports = __webpack_public_path__ + "static/media/xray2.d7499c33.png";